<script setup lang="ts">
import { screenModule } from '@/store/screen/module'
import { userModule } from '@/store/user/module'
import { computed } from 'vue'

const isDarkMode = computed(() => {
    return userModule.state.settings.isDarkMode
})

const breakpoint = computed(() => {
    return screenModule.getters.getBreakpoint()
})

const strokeColor = computed(() => {
    if (isDarkMode.value) {
        return '#03101B'
    } else {
        return '#1f3545'
    }
})
</script>

<template>
    <div class="readiness-non-numeric-unit">
        <!-- eslint-disable -->
        <svg :width="breakpoint === 'black-bear' ? '79' : '86'" height="14" viewBox="0 0 86 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M79 0.5L79.335 0.508789C82.7691 0.683124 85.5 3.5225 85.5 7C85.5 10.5899 82.5899 13.5 79 13.5H7C3.41015 13.5 0.5 10.5899 0.5 7C0.5 3.41015 3.41015 0.5 7 0.5H79Z" fill="currentColor" :stroke="strokeColor"/>
        </svg>
        <!-- eslint-enable -->
    </div>
</template>

<style lang="scss" scoped>
.readiness-non-numeric-unit {
    // noop
}
</style>
